import * as React from "react";

import { IWebexPresenceIconProps } from "./IWebexPresenceIconProps";
import { WebexApiHelper } from "../../../helpers/WebexApiHelper";
import { LocalCacheHelper } from "../../../helpers/LocalCacheHelper";
import { Loader } from "@fluentui/react-northstar";

class WebexPresenceIcon extends React.Component<IWebexPresenceIconProps> {

    // an example can be found in TabDevTest.tsx (http://localhost:3007/tabDevTest)

    private lcWebexBearerTokenFake: string;
    private lcCpbxGroupId: string;
    private apiUrlFull: string;
    private reqHeadersWebex: Headers;
    private lastSearchedCpbxIntEmail: string;
    private interval;
    private defaultDelayBeforeUpdateInS: number;
    private isLoggedInUserOfCpbxType2: boolean;
    private doShowIcon: boolean;
    private nodeJSTimeout: any;
    private lastUniqueTimeStamp: number | undefined;
    private isValidAccessToken: boolean;

    /* eslint-disable */
    constructor(props) {
        super(props);

        // console.log("start ctor WebexPresenceIcon");
        this.defaultDelayBeforeUpdateInS = 30;
        // this.isLoggedInUserOfCpbxType2 = false; // default value
        this.lcCpbxGroupId = LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe();
        this.isLoggedInUserOfCpbxType2 = LocalCacheHelper.GetLocalStorageItemCpbxUserType() === "2";
        // this.doShowIcon = this.isLoggedInUserOfCpbxType2 === true;
        // special case for now
        this.doShowIcon = this.isLoggedInUserOfCpbxType2 === true;
        this.lastUniqueTimeStamp = 0;
        this.lcWebexBearerTokenFake = LocalCacheHelper.GetLocalStorageItemCbpxUserBasicAuthStringAsString();
        this.apiUrlFull = WebexApiHelper.GetWebexUrlForPresenceGet();
        this.reqHeadersWebex = WebexApiHelper.GetWebexRequestHeadersWithAuth(this.lcWebexBearerTokenFake, this.lcCpbxGroupId);
        this.lastSearchedCpbxIntEmail = "";
        
        if (this.props.hasValidAccessToken === undefined) {

            // If no info is transmitted, assume the token not exists
            this.isValidAccessToken = false;
        } else {
            this.isValidAccessToken = this.props.hasValidAccessToken;
        }

    }
    /* eslint-enable */

    state = {
        foundUserPresenceFound: false,
        foundUserPresenceStatus: "",
        dateTimeLastFound: null,
        errorOccured: false
    }

    componentDidMount() {
        console.log("start componentDidMount WebexPresenceIcon");

        if (this.doShowIcon === false) {
            console.log("logged in user is not of cpbx-type 2 or not supported group-id > so do not get presence-state");
            return;
        }

        // this.apiUrlFull = WebexApiHelper.GetWebexUrlForPresenceGet();

        // use this auth-string for cpbx1 - yes i know it is a basic-auth-string (and NOT a bearer-token)
        // but its value does not matter - it will not be checked by proxy-component (but it needs to be there)
        // additionally this will by something like "security by obscurity" (meaning: for each logged in person
        // the request will look like a personalized request)
        // this.lcWebexBearerTokenFake = LocalCacheHelper.GetLocalStorageItemCbpxUserBasicAuthStringAsString();

        // get group-id from currently logged in user
        // proxy component will check this value
        // in case this group-id is currently supported the proxy component will return a value
        // this.lcCpbxGroupId = LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe();

        // this.reqHeadersWebex = WebexApiHelper.GetWebexRequestHeadersWithAuth(this.lcWebexBearerTokenFake, this.lcCpbxGroupId);
        // this.reqHeadersWebex = WebexApiHelper.GetWebexRequestHeadersWithAuth(this.lcWebexBearerTokenFake, this.lcCpbxGroupId+"1");

        // this.lastSearchedCpbxIntEmail = "";

        // pay attention: for initial call the function to get presence-state-value will be handled within render
        // updating the presence-status-value will be handled by using the following interval

        // check if presence-status should be updated
        if (this.props.doUpdateStatus === true && this.isValidAccessToken) {
            // console.log("yes do update presence-value regularly");
            let delayInSec: number = this.defaultDelayBeforeUpdateInS;

            // check delay-value has been passed as property-value
            if (this.props.updateDelayInSec !== undefined) {
                // console.log("this.props.updateDelayInSec IS NOT undefined");
                delayInSec = this.props.updateDelayInSec;
                // console.log("delayInSec = '" + delayInSec + "'");

                // check for stupid values
                if (delayInSec < 1 || delayInSec > 100) {
                    // console.log("delayInSec has stupid value (smaller 1 or greater 100) > so reset it to default-value");
                    delayInSec = this.defaultDelayBeforeUpdateInS;
                    // console.log("delayInSec = '" + delayInSec + "'");
                }
            } else {
                // console.log("this.props.updateDelayInSec IS undefined");
            }

            // set interval for updating
            // console.log("B: delayInSec = '" + delayInSec + "'");
            this.interval = setInterval(() => this.getWebexPresenceState(this.props.cpbxIntEmail), delayInSec * 1000);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // this.handleChange();
        // this.getWebexPresenceState(this.props.cpbxIntEmail)
        //  console.log("prevProps:", prevProps, " prevState ", prevState," snapshot ", snapshot);
        console.log("this.props.hasValidAccessToken === ", this.props.hasValidAccessToken);

        if (this.props.hasValidAccessToken === false) {
            return;
        }

        if (this.props.hasValidAccessToken === true && (prevProps.hasValidAccessToken === false || prevProps.hasValidAccessToken === null)) {
            console.log("Start WebexPresenceIcon componentDidUpdate since hasValidAccessToken is true!");
            this.getWebexPresenceState(this.props.cpbxIntEmail);
        }

        if (this.props.uniqueTimeStamp !== prevProps.uniqueTimeStamp) {
            console.log("Start componentDidUpdate WebexPresenceIcon as the page has been changed!");
            this.getWebexPresenceState(this.props.cpbxIntEmail);
        }

        if (this.state.errorOccured !== prevState.errorOccured) {
            console.log("start componentDidUpdate WebexPresenceIcon errorOccured");
            if (this.nodeJSTimeout !== null && this.nodeJSTimeout !== undefined) {
                console.log("clearTimeout for ", this.nodeJSTimeout, " ID");
                clearTimeout(this.nodeJSTimeout);
                this.nodeJSTimeout = undefined;
            };
        }
    }

    componentWillUnmount() {
        // console.log("start componentWillUnmount WebexPresenceIcon");
        this.cleanupUpdateInterval();
    }

    render() {
        // console.log("render in WebexPresenceIcon");
        // console.log("this.props.cpbxIntEmail='" + this.props.cpbxIntEmail + "' (length='" + this.props.cpbxIntEmail.length + "')");

        // check if logged in user is cpbx1-user
        if (this.doShowIcon === false) {
            console.log("logged in user is not of cpbx-type 2 or not supported group-id > so do not get presence-state");
            this.cleanupUpdateInterval();

            // maybe you want to add some additional html-data to be able to handle it better
            return (<span className="webexPresence webexPresenceIsNotCpbx2" />);
        }

        let presStatus: string = this.state.foundUserPresenceStatus;

        // yes logged in user is cpbx2-user
        if (this.props.cpbxIntEmail !== undefined &&
            this.props.cpbxIntEmail.length > 0 &&
            this.isValidAccessToken &&
            // this.lastSearchedImpId !== undefined &&
            // this.lastSearchedImpId.length > 0 &&
            // this.props.impId.toLowerCase() !== this.lastSearchedImpId.toLowerCase() ) {
            // this.props.cpbxIntEmail !== this.lastSearchedCpbxIntEmail &&
            this.props.uniqueTimeStamp !== this.lastUniqueTimeStamp
        ) {
            // this case will be e.g. for initial call or for a change in search
            // console.log("this case will be e.g. for initial call > get presence-state and return now");
            presStatus = "";
            this.lastUniqueTimeStamp = this.props.uniqueTimeStamp;
            this.lastSearchedCpbxIntEmail = this.props.cpbxIntEmail;
            this.getWebexPresenceState(this.props.cpbxIntEmail);
            // return (<span className="WebexPresence WebexPresenceIsNotCpbx2" />);
            // return (<></>);
        }

        // if (this.state.foundUserPresenceFound === false) {
        // console.log("this case will be if response got an error or has never been set (initial call)");
        // return (<></>);
        // }

        let cssClass = "";
        let statusTextResx = "";
        switch (presStatus.toLowerCase()) {
            case "active":
                // green
                cssClass = "webexPresence webexPresenceActive";
                statusTextResx = "Aktiv"; // todo: better translation
                break;
            case "inactive":
                // yellow
                cssClass = "webexPresence webexPresenceInactive";
                statusTextResx = "Inaktiv"; // todo: better translation
                break;
            case "call":
                // red
                cssClass = "webexPresence webexPresenCall";
                statusTextResx = "Im Telefonat"; // todo: better translation
                break;
            case "donotdisturb":
                // red
                // maybe 'offline' does also exist? (for cpbx1 it exists)
                cssClass = "webexPresence webexPresenceDoNotDisturb";
                statusTextResx = "Nicht stören"; // todo: better translation
                break;
            case "meeting":
                // red
                cssClass = "webexPresence webexPresenceMeeting";
                statusTextResx = "Im Termin"; // todo: better translation
                break;
            case "outofoffice":
                // red
                cssClass = "webexPresence webexPresenceOutOfOffice";
                statusTextResx = "Nicht anwesend"; // todo: better translation
                break;
            case "presenting":
                // red
                cssClass = "webexPresence webexPresencePresenting ";
                statusTextResx = "Teilt den Bildschirm"; // todo: better translation
                break;
            case "pending":
                // transparent or grey
                cssClass = "webexPresence webexPresencePending";
                statusTextResx = "Unbekannt"; // todo: better translation
                break;
            default:
                // transparent or grey
                cssClass = "webexPresence webexPresenceUnknown";
                statusTextResx = "Unbekannt"; // todo: better translation
                break;
        }

        let ladeAnimationByTupel = <></>;
        if (this.state.errorOccured === true) {
            cssClass += " webexPresenceErrorOccured";
            ladeAnimationByTupel = (
                <div className="cpbxladeAnimationByTupel">
                    <Loader className="cpbxladeAnimationByTupelSmallest" size='smallest'>Loading</Loader>
                </div>
            );
        }

        let statusTextResxFullTitle: string = statusTextResx;

        // presence status value, a long text is displayed.
        if (this.props.doShowIntEmailInTitle !== undefined && this.props.doShowIntEmailInTitle === true) {
            statusTextResxFullTitle += " - cpbxIntEmail '" + this.props.cpbxIntEmail + "'";
        }

        if (this.props.doShowDateTimeInTitle !== undefined && this.props.doShowDateTimeInTitle === true) {
            statusTextResxFullTitle += " - ermittelt '" + this.state.dateTimeLastFound + "'";
        }

        // todo: differentiate between desktop and mobile rendering
        return (
            <div className={"webexPresenceParent"}>
                {ladeAnimationByTupel}
                <span className={cssClass} title={statusTextResxFullTitle} />
                <span className={"webexPresenceStatusText " + presStatus.toLowerCase()}>
                    {statusTextResx}
                </span>
            </div>
        );
    }

    cleanupUpdateInterval() {
        console.log("cleanupUpdateInterval");
        // clear intervall just in case we set it
        if (this.props.doUpdateStatus === true) {
            clearInterval(this.interval);
        }
    }

    getWebexPresenceState(inpCpbxIntEmail: string) {
        // console.log("start getWebexPresenceState within WebexPresenceIcon");
        // console.log("inpCpbxIntEmail='" + inpCpbxIntEmail + "'");

        // check if logged in user is cpbx1-user
        // console.log("this.isLoggedInUserOfCpbxType2='" + this.isLoggedInUserOfCpbxType2 + "'");
        if (this.doShowIcon === false) {
            console.log("logged in user is not of cpbx-type 2 or not supported group-id > so do not get presence-state");
            this.cleanupUpdateInterval();

            // maybe you want to add some additional html-data to be able to handle it better
            return;
        }

        if (inpCpbxIntEmail.length === 0) {
            console.log("length of inpCpbxIntEmail is 0 > return now!");
            return;
        }

        // https://webexapis.com/v1/people/?email=thomas01.test02@deutschland-lan.de
        let apiUrlFullWithParam: string = this.apiUrlFull;

        // add email for person whos presence state is searched
        // todo: maybe we should take care of special characters like german umlaute within email
        apiUrlFullWithParam += inpCpbxIntEmail;
        // console.log("apiUrlFullWithParam='" + apiUrlFullWithParam + "'");

        fetch(apiUrlFullWithParam, {
            method: "GET",
            headers: this.reqHeadersWebex,
            redirect: "follow"
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("response not ok");
                    this.setState({
                        foundUserPresenceFound: false,
                        foundUserPresenceStatus: "",
                        dateTimeLastFound: new Date().toLocaleString(),
                        errorOccured: true
                    });
                    this.cleanupUpdateInterval();
                    // some additional hints on console
                    if (response.status === 401) {
                        console.log("401 > maybe bearer token used by proxy is not valid");
                    } else if (response.status === 429) {
                        let retryAfterValueInSec:number = 1;
                        response.headers.forEach(function(val, key) {
                            if (key === "retry-after") {
                                retryAfterValueInSec = parseInt(val);
                            }
                        });
                        this.nodeJSTimeout = setTimeout(() => this.getWebexPresenceState(inpCpbxIntEmail), 1000 * retryAfterValueInSec);
                        // for test
                        // this.nodeJSTimeout = setTimeout(() => console.log(" Fehler 429 for ",inpCpbxIntEmail), 1000 * 6);
                        console.log("this.nodeJSTimeout ID == ", this.nodeJSTimeout, " for ", inpCpbxIntEmail);
                        return;
                    } else {
                        console.log("403 > maybe some header-data is not valid");
                    }
                    console.log("you may find further information in http-response or its headers (e.g. 'X-TeamsApp-Message') or in server-logs for proxy-component");

                    throw new Error("Response not ok");
                }
            })
            .then(data => {
                // console.log("got data in WebexPresenceIcon");
                /* example response as json
                    {
                        "notFoundIds": null,
                        "items": [
                            {
                                "id": "Y2lzY29zcGFyazovL3VzL1BFT1BMRS82NzM5MmUxMy1jZGFkLTQwYjctODc5NC03NjA4MWVmOWI5MTU",
                                "emails": [
                                    "thomas01.test02@deutschland-lan.de"
                                ],
                                "phoneNumbers": [
                                    {
                                        "type": "work",
                                        "value": "+4922842270937"
                                    }
                                ],
                                "displayName": "Thomas Kattenbeck",
                                "nickName": "Thomas",
                                "firstName": "Thomas",
                                "lastName": "Kattenbeck",
                                "orgId": "Y2lzY29zcGFyazovL3VzL09SR0FOSVpBVElPTi8xNzQxYzJiYy1jN2IyLTRlMjAtYmRkZS01ODM1NTg3ODkzODc",
                                "created": "2021-10-22T11:16:49.151Z",
                                "lastModified": "2021-10-22T11:16:49.774Z",
                                "status": "unknown",
                                "type": "person"
                            }
                        ]
                    }
                */

                // check if data exists (for HTTP-FETCH it does not exist for initial request because it results in 401)
                if (data !== undefined) {
                    // check result
                    // console.log("data", data);
                    // console.log("data.items.length='" + data.items.length + "'");
                    if (data.items.length === 0) {
                        // nothing returned > this is no expected result
                        this.setState({
                            foundUserPresenceFound: false,
                            foundUserPresenceStatus: "",
                            dateTimeLastFound: null,
                            errorOccured: true
                        });
                    } else {
                        // 1 result expected
                        // only logged in users with role administrator may get more than 1 result (but we searched for exactly one email-address so index 0 is valid)
                        this.setState({
                            foundUserPresenceFound: true,
                            foundUserPresenceStatus: data.items[0].status ?? "",
                            dateTimeLastFound: new Date().toLocaleString(),
                            errorOccured: false
                        });
                    }
                }
            })
            .catch(error => console.log("error", error));
    }
}

export default WebexPresenceIcon;
